export default "__VITE_ASSET__786df02d__"